import request from '@/utils/request'

const uploadImage = (image) => {
  const formData = new FormData()
  formData.append('media', image)

  return request({
    url: `/api/uploads`,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData
  })
}

export default {
  uploadImage
}
